<template>
  <div>
    <v-col>
      <div v-if="field.is_corneal_laser">
        <v-row>
          <v-sheet class="iol-opt-v2-sheet col-12">
            <v-row>
              <v-col>
                Corneal refractive surgery: <br />
                &#8594; {{ field.corneal_laser_type || '--' }}
              </v-col>
              <v-col>
                Pre-LVC anterior corneal radius:
                {{ field.pre_lvc_arc || '--' }} mm <br />
                Corrected ametropia:
                {{ field.laser_amount || '--' }} D <br />
              </v-col>
            </v-row>
          </v-sheet>
        </v-row>
      </div>
      <div v-else>
        <iol-switch-field :fields="field.is_corneal_laser" />
      </div>
    </v-col>
  </div>
</template>

<style>
.iol-opt-v2-sheet {
  padding: 10px;
  padding-top: 24px;
  background-color: #a4bdcf !important;
  border-radius: 3px !important;
}
</style>

<script>
import IolTextField from '@/components/elementary/IolTextField.vue'
import IolSwitchField from '@/components/elementary/IolSwitchField.vue'

export default {
  name: 'iol-result-cornelal-refractive-surgery',
  props: ['fields'],
  components: {
    IolTextField,
    IolSwitchField,
  },
  data() {
    return {
      field: this.fields,
    }
  },
  created() {
    this.$emit('fields', this.field)
  },
}
</script>
